import userInitialState from "./user.initialstate"
import { LOGIN, LOGOUT, SET_LOADING, SET_USERDETAILS, SET_LANGUAGE, SET_OTP_TIME, SET_EMAIl_VERIFIED, SET_DARK_MODE } from "./user.types";


const userReducer = (state = userInitialState, action) => {


    switch (action.type) {

        case LOGIN:
            return {
                ...state,
                isLoggedIn: true,
                userDetails: action.payload.userDetails,
                token: action.payload.token,
                // language: action.payload.language ?? 'English',
                tempEmail: action.payload.tempEmail,
                isEmailVerified: action.payload.isEmailVerified ?? false
            }

        case SET_USERDETAILS:
            return {
                ...state,
                userDetails: action.payload.userDetails
            }

        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,

            }

        case SET_EMAIl_VERIFIED:
            return {
                ...state,
                isEmailVerified: action.payload,

            }

        case SET_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            }

        case SET_OTP_TIME:
            return {
                ...state,
                otpSendTime: action.payload,

            }

        case SET_DARK_MODE:
            return {
                ...state,
                isDarkMode: action.payload,

            }

        case LOGOUT:
            // localStorage.clear();
            return {
                ...state,
                isLoggedIn: false,
                userDetails: {},
                token: "",
                isLoading: false,
                tempEmail: "",
                otpSendTime: "",
                isEmailVerified: false
            }

        default:
            return state;
    }
};

export default userReducer;